import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";
import Navbar from "components/Navbars/AuthNavbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import { ChromePicker } from "react-color";

const AddItem = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  // const colorPickerRef = useRef();
  const location = useLocation();
  const { item } = location.state || {}; // Extract item data from location state
  const [currency, setCurrency] = useState("");
  const [formData, setFormData] = useState({
    item: item ? item.itemName : "",
    itemCost: item ? item.itemCost : "",
    description: item ? item.itemDescription : "",
    color: item ? item.color : "",
    defaulttext: item ? item.defaultText : "",
    tabOrder: item ? String(item.tabOrder) : "",
  });
  const [color, setColor] = useState(
    item ? item.color || "#000000" : "#000000"
  );

  const [options, setOptions] = useState([]);
  //Get Useid form localStorage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  const [validationMessage, setValidationErrors] = useState({
    item: "",
    itemCost: "",
    description: "",
    tabOrder: "",
    defaulttext: "",
  });

  //here is the code of the color picker
  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChangeComplete = (newColor) => {
    setColor(newColor.hex);
  };

  const handleInputChange = (event) => {
    const inputColor = event.target.value;
    // Verify if input is a valid HEX color
    if (/^#[0-9A-F]{6}$/i.test(inputColor)) {
      setColor(inputColor);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Item/GetAllTabsofUsers?UserId=${userId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setOptions(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };
    inputRef.current.focus();
    fetchCurrencyData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      let response;
      if (item) {
        // Update item if item is provided
        response = await fetch(`${BASE_URL}/api/Item/UpdateItem`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            itemID: item.itemID,
            itemName: formData.item,
            itemCost: formData.itemCost,
            itemDescription: formData.description,
            color: color,
            defaultText: formData.defaulttext,
            tabOrder: formData.tabOrder,
          }),
        });
      } else {
        // Add new item if no item is provided
        response = await fetch(`${BASE_URL}/api/Item/InsertItem`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: userId,
            itemName: formData.item,
            itemCost: formData.itemCost,
            itemDescription: formData.description,
            color: color,
            defaultText: formData.defaulttext,
            tabOrder: formData.tabOrder,
          }),
        });
      }

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: item
            ? "Item updated successfully!"
            : "Item added successfully!",
        });
        console.log(
          item ? "Item updated successfully!" : "Item added successfully!"
        );
        history.push("/getAllItems");
        setLoading(false);
      } else {
        const errorMessage = await response.text();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
        setLoading(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Sorry!",
        text: "Item is already exited.",
      });
      setLoading(false);
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (formData.item.trim() === "") {
      newErrors.item = "Item is required.";
      isValid = false;
    }

    if (formData.itemCost.trim() === "") {
      newErrors.itemCost = "Item cost is required.";
      isValid = false;
    }

    if (formData.description.trim() === "") {
      newErrors.description = "Description is required.";
      isValid = false;
    }

    if (typeof formData.tabOrder === "string") {
      if (formData.tabOrder.trim() === "") {
        newErrors.tabOrder = "Tab order is required.";
        isValid = false;
      }
    } else {
      // Handle the case where tabOrder is not a string
      newErrors.tabOrder = "Tab order should be a valid string.";
      isValid = false;
    }

    setValidationErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
    return isValid;
  };

  return (
    <>
      <Navbar />

      <div className="cust-div" style={{ minHeight: "550px" }}>
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4 h-full">
          <div className="flex content-center items-center justify-center h-full">
            <div className="w-full">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div className="rounded-t mb-0 px-4 py-3">
                  <div>
                    <h1 className="text-2xl font-bold ">
                      {item ? "Update Item" : "Add New Item"}
                    </h1>
                  </div>
                  {/* <hr className="mt-1 border-b-1 border-blueGray-300" /> */}
                </div>
                <div className="flex-auto px-4 lg:px-10 py-3 pt-0">
                  <form>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="item"
                        >
                          Item
                        </label>
                        <input
                          type="text"
                          id="item"
                          name="item"
                          maxLength={50}
                          value={formData.item}
                          onChange={handleChange}
                          ref={inputRef} // Attach the ref to the input element
                          className="mt-1 p-2 border rounded w-full"
                          placeholder="Item"
                        />
                        <div className="text-red-500 text-xs mt-1">
                          {validationMessage.item}
                        </div>
                      </div>
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="itemCost"
                        >
                          Item Cost/Unit({currency})
                        </label>
                        <input
                          type="text"
                          id="itemCost"
                          name="itemCost"
                          maxLength={30}
                          value={formData.itemCost}
                          onChange={handleChange}
                          className="mt-1 p-2 border rounded w-full"
                          placeholder={`Item Cost/Unit (${currency})`}
                          onKeyPress={(e) => {
                            // Check if the pressed key is not a digit
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <div className="text-red-500 text-xs mt-1">
                          {validationMessage.itemCost}
                        </div>
                      </div>
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="tabOrder"
                        >
                          Tab Order
                        </label>
                        <select
                          id="tabOrder"
                          name="tabOrder"
                          value={formData.tabOrder}
                          onChange={handleChange}
                          className="mt-1 p-2 border rounded w-full"
                        >
                          <option value="" disabled>
                            Select Tab Order
                          </option>
                          {options.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>

                        <div className="text-red-500 text-xs mt-1">
                          {validationMessage.tabOrder}
                        </div>
                      </div>
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="description"
                        >
                          Description
                        </label>
                        <textarea
                          id="description"
                          name="description"
                          maxLength={70}
                          value={formData.description}
                          onChange={handleChange}
                          className="mt-1 p-2 border rounded w-full"
                          placeholder="Description"
                        />

                        <div className="text-red-500 text-xs mt-1">
                          {validationMessage.description}
                        </div>
                      </div>
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="defaulttext"
                        >
                          Default Text
                        </label>
                        <textarea
                          id="defaulttext"
                          name="defaulttext"
                          maxLength={70}
                          value={formData.defaulttext}
                          onChange={handleChange}
                          className="mt-1 p-2 border rounded w-full"
                          placeholder="Default Text"
                        />

                        <div className="text-red-500 text-xs mt-1">
                          {validationMessage.defaulttext}
                        </div>
                      </div>
                      <div>
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="choosecolor"
                        >
                          Choose Color
                        </label>
                        <div style={{ display: "inline-block" }}>
                          <input
                            type="text"
                            value={color}
                            onChange={handleInputChange}
                            onClick={handleClick}
                            style={{ backgroundColor: color }}
                            className="border"
                            placeholder="Choose color"
                          />
                          {displayColorPicker && (
                            <div style={{ position: "absolute", zIndex: "2" }}>
                              <div
                                style={{
                                  position: "fixed",
                                  top: "0px",
                                  right: "0px",
                                  bottom: "0px",
                                  left: "0px",
                                }}
                                onClick={handleClose}
                              />
                              <ChromePicker
                                color={color}
                                onChangeComplete={handleChangeComplete}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="text-right mt-3 flex flex-row justify-end">
                        <button
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 "
                          onClick={() => history.push("/getAllItems")}
                        >
                          Back ot Item List
                        </button>
                        <button
                          type="button"
                          onClick={handleSubmit}
                          className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                        >
                          {item ? "Update" : "Save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AddItem;
